import { useNavigate } from "react-router";

type ErrorPageProps = object;

export const ErrorPage: React.FC<ErrorPageProps> = () => {
  const navigate = useNavigate();

  return (
    <div className="container-fluid min-vh-80 d-flex justify-content-center">
      <div className="text-center p-4 mt-3">
        <div
          className="d-inline-flex align-items-center justify-content-center rounded-circle bg-secondary mb-3"
          style={{ width: 96, height: 96, opacity: 0.5 }}
          role="img"
          aria-label="Error icon placeholder"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="64"
            fill="currentColor"
            className="bi bi-bug"
            viewBox="0 0 16 16"
          >
            <path d="M4.355.522a.5.5 0 0 1 .623.333l.291.956A5 5 0 0 1 8 1c1.007 0 1.946.298 2.731.811l.29-.956a.5.5 0 1 1 .957.29l-.41 1.352A5 5 0 0 1 13 6h.5a.5.5 0 0 0 .5-.5V5a.5.5 0 0 1 1 0v.5A1.5 1.5 0 0 1 13.5 7H13v1h1.5a.5.5 0 0 1 0 1H13v1h.5a1.5 1.5 0 0 1 1.5 1.5v.5a.5.5 0 1 1-1 0v-.5a.5.5 0 0 0-.5-.5H13a5 5 0 0 1-10 0h-.5a.5.5 0 0 0-.5.5v.5a.5.5 0 1 1-1 0v-.5A1.5 1.5 0 0 1 2.5 10H3V9H1.5a.5.5 0 0 1 0-1H3V7h-.5A1.5 1.5 0 0 1 1 5.5V5a.5.5 0 0 1 1 0v.5a.5.5 0 0 0 .5.5H3c0-1.364.547-2.601 1.432-3.503l-.41-1.352a.5.5 0 0 1 .333-.623M4 7v4a4 4 0 0 0 3.5 3.97V7zm4.5 0v7.97A4 4 0 0 0 12 11V7zM12 6a4 4 0 0 0-1.334-2.982A3.98 3.98 0 0 0 8 2a3.98 3.98 0 0 0-2.667 1.018A4 4 0 0 0 4 6z" />
          </svg>
          <span className="visually-hidden">Icon</span>
        </div>
        <h1 className="h3 fw-semibold mb-2">
          Oh nein, das hätte nicht passieren dürfen!
        </h1>
        <p className="text-muted mb-0">
          Bitte versuchen es nochmal. <br />
          Wenn der Fehler wieder auftritt, wenden Sie sich bitte an{" "}
          <strong>
            <a href="mailto:sperrdatei@bik-gmbh.de">sperrdatei@bik-gmbh.de</a>
          </strong>
        </p>
        <button className="btn btn-primary mt-3" onClick={() => navigate(-1)}>
          Erneut laden
        </button>
      </div>
    </div>
  );
};
